import Close from "@assets/svg/close.svg";
import DropDown from "@components/dropDown";
import { Basket, ExitModal, Spinner } from "@components/ui";
import Modal from "@components/ui/Modal";
import Menu from "assets/svg/menu.svg";
import { Button } from "components";
import { useRouter } from "next/router";
import React, { useState } from "react";
import useProfile from "src/hooks/useProfile";
import { generateUuidForReactList } from "src/utils";

import Sidebar, { Menus, MenuType } from "../Sidebar";

function MouseOver(
  event: React.MouseEvent<HTMLElement>,
  color: string,
  deg: string
) {
  (
    event.target as HTMLInputElement
  ).style.background = `linear-gradient(${deg}, ${color} 10.92%, rgba(79, 155, 11, 0) 86.78%)`;
}

function MouseOut(event: React.MouseEvent<HTMLElement>) {
  (event.target as HTMLInputElement).style.background = "";
}

const CategoryComponent = ({
  name,
  color,
  id,
  children,
  onShowVideoModal,
}: any) => {
  const [hover, setHover] = useState(false);
  const handleMouseOver = (action: boolean) => {
    setHover(action);
  };

  return (
    <div
      // key={id?.toString()}
      className={`group ml-[10px] flex h-full items-center border-t-4`}
      onMouseEnter={() => handleMouseOver(true)}
      onMouseLeave={() => handleMouseOver(false)}
      style={{
        borderColor: color,
        background: hover
          ? `linear-gradient(180deg, ${color} 10.92%, rgba(79, 155, 11, 0) 86.78%)`
          : "black",
      }}
    >
      <DropDown
        wrapper_class="!w-min z-[60]"
        titleClass="pr-2 transition-all"
        menu_class="bg-transparent border-none !w-full h-auto !rounded-t-none"
        svg_class="fill-white w-5 ml-2 min-w-[15px]"
        title={`${name}`}
        btnClass="bg-transparent hover:!text-white/90 !text-white !text-xs lg:!text-sm !gap-x-2 !hover:bg-transparent whitespace-nowrap !rounded-none !place-content-start border-0 !pl-0 !pr-0"
      >
        <ul className="z-40 animate-fade-in-down list-none space-y-2 rounded-b-lg bg-black py-2 text-sm text-white/90">
          {(children as MenuType["children"])?.map(
            ({ title, isTitle, isNewTab, onClick, path }) =>
              isTitle > 0 ? (
                path ? (
                  <a
                    href={path as string}
                    target={isNewTab ? "_blank" : "_self"}
                    onMouseEnter={(e) => MouseOver(e, color, "-90deg")}
                    onMouseLeave={MouseOut}
                    key={generateUuidForReactList()}
                    className={`block cursor-pointer px-2 py-1 ${
                      isTitle === 2 && "!px-4 text-[#808080] hover:text-[#fff]"
                    }`}
                    // onClick={() => onClick() ?? router.push(path ?? "")}
                  >
                    {title}
                  </a>
                ) : (
                  <button
                    onMouseEnter={(e) => MouseOver(e, color, "-90deg")}
                    onMouseLeave={MouseOut}
                    key={generateUuidForReactList()}
                    className={`block cursor-pointer px-2 py-1 ${
                      isTitle === 2 && "!px-4 text-[#808080] hover:text-[#fff]"
                    }`}
                    onClick={() => onShowVideoModal(title)}
                  >
                    {title}
                  </button>
                )
              ) : (
                <span
                  className="mb-1 block px-2"
                  key={generateUuidForReactList()}
                >
                  {title}
                </span>
              )
          )}{" "}
        </ul>
      </DropDown>
    </div>
  );
};

const LinkComponent = ({ path, name, color, onClick, id }: any) => {
  return (
    // <Link href={path}>
    <a
      href={path}
      target={path !== "/" ? "_blank" : "_parent"}
      // key={id?.toString()}
      onMouseEnter={(e) => MouseOver(e, color, "180deg")}
      onMouseLeave={MouseOut}
      style={{
        borderColor: color,
      }}
      className={`ml-[10px] flex h-full cursor-pointer items-center whitespace-nowrap border-t-4 px-1 text-xs transition-all hover:text-white/80 lg:px-3 lg:text-sm`}
    >
      {name}
    </a>
    // </Link>
  );
};

const Navbar: React.FC = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [OpenSideBar, setOpenSideBar] = useState(false);
  const router = useRouter();
  const [isShowVideoModal, setIsShowVideoModal] = useState({
    isShow: false,
    url: "",
  });
  const onShowVideoModal = (data: string) => {
    setIsShowVideoModal({
      isShow: true,
      url: `/videos/${data}.mp4`,
    });
  };
  const handleCloseSidebar = (e: any) => {
    e && e?.stopPropagation();
    setOpenSideBar(false);
    document.body.classList.remove("overflow-hidden");
    document.getElementById("raychatBtn")?.classList.remove("!hidden");
    document.getElementById("najva-bell")?.classList.remove("!hidden");
    document
      .getElementById("najva-bell-denied-help")
      ?.classList.remove("!hidden");
  };
  const onOpenSidebar = () => {
    setOpenSideBar(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("raychatBtn")?.classList.add("!hidden");
    document.getElementById("najva-bell")?.classList.add("!hidden");
    document.getElementById("najva-bell-denied-help")?.classList.add("!hidden");
  };

  const { isLoading, isSuccess, isIdle } = useProfile();

  return (
    <>
      <ExitModal {...{ isShowModal, setIsShowModal }} />
      {OpenSideBar == true ? (
        <div className="fixed bottom-0 left-0 top-0 z-[101] flex w-full -translate-x-0 transform overflow-hidden transition-all duration-300">
          <Sidebar
            type="MAIN"
            isOpen={OpenSideBar}
            onClose={handleCloseSidebar}
          />
        </div>
      ) : (
        <div className="fixed bottom-0 left-0 right-0 top-0 z-10 flex w-full -translate-x-full transform overflow-hidden transition-all duration-300">
          <Sidebar
            type="MAIN"
            isOpen={OpenSideBar}
            onClose={handleCloseSidebar}
          />
        </div>
      )}
      <div className="flex h-[70px] w-full items-center justify-between bg-black px-[4%] text-white lg:px-[2%] 2xl:px-[10%]">
        <div className="flex h-full items-center">
          <div>
            <img
              loading="lazy"
              onClick={() => router.push("/")}
              src="/images/logo-white.png"
              className="w-[51px] cursor-pointer self-center object-contain 2xl:h-[47px] 2xl:w-[62px]"
              alt="لوگو"
              width="200"
              height="91"
            />
          </div>
          <ul className="mr-2 hidden h-full grid-flow-col items-center text-sm lg:ml-12 lg:mr-4 xl:grid">
            {Menus.map(
              (
                { color, name, path, onClick, type, id, children },
                index: number
              ) =>
                id !== 8 && type == "link" ? (
                  <LinkComponent
                    key={id?.toString()}
                    {...{ path, name, color, onClick, id }}
                  />
                ) : (
                  type == "category" && (
                    <CategoryComponent
                      key={id?.toString()}
                      {...{
                        path,
                        name,
                        color,
                        onClick,
                        id,
                        children,
                        onShowVideoModal,
                      }}
                    />
                  )
                )
            )}
          </ul>
        </div>
        <div className="hidden text-sm xl:flex">
          <div className="flex items-center">
            <Button
              onClick={() => router.push("/app-download")}
              CClassName="h-[39px] whitespace-nowrap px-4 bg-[#FBCF32] ml-2 text-black"
            >
              اپ دادبانان
            </Button>
          </div>
          {isSuccess && (
            <div className="relative flex items-center gap-x-2">
              <span
                onClick={() => {
                  document.body.classList.remove("overflow-hidden");
                  router.push("/student/dashboard");
                }}
                className="mt-2 flex cursor-pointer gap-x-2 rounded-full p-3 hover:bg-gradient-to-l hover:from-[#0577AF] hover:text-white/90 hover:transition-all"
              >
                داشبورد
              </span>
              <Basket />
            </div>
          )}{" "}
          {isLoading && <Spinner fill="white" />}
          {isIdle && (
            <Button
              CClassName="h-[39px] whitespace-nowrap bg-blue-550 px-4"
              onClick={() => router.push("/auth")}
            >
              ورود و ثبت نام
            </Button>
          )}{" "}
        </div>
        <div className="flex cursor-pointer items-center text-sm xl:hidden">
          {isSuccess && (
            <div className="relative flex items-center gap-x-2">
              <span
                onClick={() => {
                  document.body.classList.remove("overflow-hidden");
                  router.push("/student/dashboard");
                }}
                className="mt-2 flex cursor-pointer gap-x-2 rounded-full p-3 hover:bg-gradient-to-l hover:from-[#0577AF] hover:text-white/90 hover:transition-all"
              >
                داشبورد
              </span>
              <Basket />
            </div>
          )}{" "}
          {/* {!isIdle && <Basket />} */}
          {isLoading && <Spinner fill="white" />}
          {isIdle && (
            <Button
              CClassName="h-[39px] whitespace-nowrap bg-blue-550 ml-2 px-4"
              onClick={() => router.push("/auth")}
            >
              ورود و ثبت نام
            </Button>
          )}{" "}
          <Menu onClick={() => onOpenSidebar()} />
        </div>
      </div>
      <Modal
        visible={isShowVideoModal.isShow}
        onClose={() =>
          setIsShowVideoModal((prev) => ({ ...prev, isShow: true }))
        }
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video
            controls
            src={isShowVideoModal.url}
            className="h-full w-full"
          />
          <Close
            onClick={() =>
              setIsShowVideoModal((prev) => ({ ...prev, isShow: false }))
            }
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
        </div>
      </Modal>
    </>
  );
};

export default Navbar;
